import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {QueryBlockOperator} from '../../../models/query-block';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

@Component({
  selector: 'app-search-query-operator-toggle',
  imports: [
    MatButtonToggleModule
  ],
  templateUrl: './search-query-operator-toggle.component.html',
  styleUrl: './search-query-operator-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchQueryOperatorToggleComponent {
  operatorInput = input<QueryBlockOperator>(QueryBlockOperator.AND);
  operatorChange = output<QueryBlockOperator>();

  protected readonly QueryBlockOperator = QueryBlockOperator;
}
